import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import VerCustomerClustersDatatable from '../common/ver-customer-clusters-datatable';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

export class Ver_customer_clusters extends Component {

    constructor(props) {
        super(props);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.state = {
            results: [],
            temp: [],
        };
    }

    onChangeFilter(e) {
        this.setState({
            filter: e.target.value
        }, function () {
        });

        const val = e.target.value.toLowerCase();
        if (this.state.temp.length != 0) {
          var columns = Object.keys(this.state.temp[0]);
          columns.splice(columns.length);

          if (!columns.length)
            return;
          const rows = this.state.temp.filter(function (d) {
            for (let i = 0; i <= columns.length; i++) {
              let column = columns[i];
              if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
                return true;
              }
            }
          });
          this.setState({
            results: rows
        }, function () {
            this.renderResults(this.state.results.length);
        });
        }

        e.preventDefault();
      }

    componentWillMount() {
        this.getDataCustomerClusters();
    }

    showStatus(results){
		for (let i = 0; i < results.length; i++){
			if( (results[i]['cluster_status'] === 'ACTIVO') ){
				results[i]['cluster_status'] = <i className="fa fa-circle font-success f-12"/>;
			}else{
				results[i]['cluster_status'] = <i className="fa fa-circle font-danger f-12"/>;
            }
		}
		return results;
	}

    getDataCustomerClusters(){
        var user = AuthService.getCurrentUser();
        ApiService.getCustomerClusters(user.token).then(
            (res) => {
                if (!res || !res.data || !Array.isArray(res.data)) {
                    this.setState({ data_customer_clusters: [] });
                    return;
                }
                const items = this.showStatus(res.data).map(function(row) {
                    return {
                        ['#']: row.id,
                        id: row.id,
                        Nombre : row.cluster_name,
                        Código : row.cluster_code || '-',
                        Estado : row.cluster_status,
                        data : row,
                    }
                 })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    renderResults(length){
		return this.state.results.length === 0
			? 'No hay datos.'
			: <VerCustomerClustersDatatable
            multiSelectOption={false}
            myData={this.state.results}
            pageSize={length<=10?length:10}
            pagination={true}
            class="-striped -highlight"
        />
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Grupos de Clientes" parent="Promociones" />
                {/* <!-- Container-fluid starts--> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Gestión de Campañas WhatsApp</h5>
                                </div>
                                <div className="card-body">
                                    <div className="alert alert-info" role="alert">
                                        <strong>Flujo de trabajo:</strong> Desde aquí puedes gestionar grupos de clientes, colecciones de productos y crear campañas de WhatsApp.
                                    </div>

                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <div className="card" style={{ backgroundColor: '#f8f9fa' }}>
                                                <div className="card-body text-center">
                                                    <i className="fa fa-users" style={{ fontSize: '3rem', color: '#28a745' }}></i>
                                                    <h6 className="mt-3">Paso 1: Grupos de Clientes</h6>
                                                    <p className="text-muted">Organiza tus clientes en grupos</p>
                                                    <Link to={`${process.env.PUBLIC_URL}/add-customer-cluster`} className="btn btn-success btn-sm">
                                                        <i className="fa fa-plus mr-1"></i> Crear Grupo
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card" style={{ backgroundColor: '#f8f9fa' }}>
                                                <div className="card-body text-center">
                                                    <i className="fa fa-tags" style={{ fontSize: '3rem', color: '#17a2b8' }}></i>
                                                    <h6 className="mt-3">Paso 2: Colecciones de Productos</h6>
                                                    <p className="text-muted">Agrupa productos para tus campañas</p>
                                                    <Link to={`${process.env.PUBLIC_URL}/product-collections`} className="btn btn-info btn-sm">
                                                        <i className="fa fa-th-large mr-1"></i> Ver Colecciones
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card" style={{ backgroundColor: '#f8f9fa' }}>
                                                <div className="card-body text-center">
                                                    <i className="fa fa-whatsapp" style={{ fontSize: '3rem', color: '#25d366' }}></i>
                                                    <h6 className="mt-3">Paso 3: Campañas WhatsApp</h6>
                                                    <p className="text-muted">Crea y gestiona tus campañas</p>
                                                    <Link to={`${process.env.PUBLIC_URL}/whatsapp-campaigns`} className="btn btn-primary btn-sm">
                                                        <i className="fa fa-paper-plane mr-1"></i> Ver Campañas
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr />

                                    <h5 className="mt-4 mb-3">Grupos de Clientes</h5>
                                    <div className="clearfix"></div>
                                    <div id="basicScenario" className="product-physical">
                                    <div className="col-md-6 table-filter">
                                    <input
                                        placeholder="Escriba para filtrar todas las columnas"
                                        name="filter"
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        onInput={this.onChangeFilter}
                                    />
                                    </div>
                                        {this.renderResults()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Container-fluid Ends--> */}
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_customer_clusters
